/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Center,
  VStack,
  Text,
  Icon,
  useColorModeValue
} from '@chakra-ui/react';
import { FiBook, FiSearch, FiFilter } from 'react-icons/fi';

interface EmptyStateProps {
  type: 'books' | 'search' | 'filter';
  title: string;
  description?: string;
  actionText?: string;
}

export function EmptyState({
  type,
  title,
  description,
  actionText
}: EmptyStateProps) {
  const textColor = useColorModeValue('gray.500', 'gray.400');
  const subTextColor = useColorModeValue('gray.400', 'gray.500');

  const getIcon = () => {
    switch (type) {
      case 'books':
        return FiBook;
      case 'search':
        return FiSearch;
      case 'filter':
        return FiFilter;
      default:
        return FiBook;
    }
  };

  const getDefaultDescription = () => {
    switch (type) {
      case 'books':
        return 'Nenhum livro encontrado para este período';
      case 'search':
        return 'Digite um CPF para buscar os livros recebidos';
      case 'filter':
        return 'Ajuste os filtros para ver os resultados';
      default:
        return '';
    }
  };

  return (
    <Center p={8}>
      <VStack spacing={4}>
        <Icon
          as={getIcon()}
          boxSize={12}
          color={textColor}
          opacity={0.6}
        />
        <Text fontSize="lg" color={textColor} textAlign="center">
          {title}
        </Text>
        <Text fontSize="sm" color={subTextColor} textAlign="center" maxW="300px">
          {description || getDefaultDescription()}
        </Text>
        {actionText && (
          <Text fontSize="xs" color={subTextColor} textAlign="center">
            {actionText}
          </Text>
        )}
      </VStack>
    </Center>
  );
}
